const ai = {
  // General
  aiPowered: 'AI Powered',
  generating: 'Generating...',
  regenerate: 'Regenerate',
  apply: 'Apply',
  cancel: 'Cancel',
  copy: 'Copy',
  copied: 'Copied',

  // Coming Soon
  comingSoon: 'Coming Soon',
  comingSoonDesc: 'This feature is under development and will be available soon',

  // Description Generator
  description: {
    title: 'Smart Description Generator',
    subtitle: 'Let AI write a professional description for your property',
    inputLabel: 'Basic property information',
    inputPlaceholder: 'Write notes about the property (location, features, nearby amenities...)',
    generate: 'Generate Description',
    resultLabel: 'Suggested Description',
    toneLabel: 'Writing Style',
    tones: {
      professional: 'Professional',
      friendly: 'Friendly',
      luxury: 'Luxury',
      simple: 'Simple',
    },
    lengthLabel: 'Description Length',
    lengths: {
      short: 'Short',
      medium: 'Medium',
      long: 'Long',
    },
    tips: {
      title: 'Tips for the best description',
      tip1: 'Mention the location and neighborhood in detail',
      tip2: 'Highlight unique property features',
      tip3: 'Mention proximity to schools, mosques, and services',
      tip4: 'Specify property size and number of rooms',
    },
  },

  // Title Improver
  title: {
    title: 'Title Improver',
    subtitle: 'Improve your listing title to attract more views',
    currentTitle: 'Current Title',
    currentTitlePlaceholder: 'Enter your current listing title',
    suggestions: 'Suggested Titles',
    improve: 'Improve Title',
    tips: {
      title: 'Tips for an attractive title',
      tip1: 'Mention property type and location',
      tip2: 'Add a standout feature (pool, garden, view)',
      tip3: 'Specify room count if notable',
      tip4: 'Avoid overly long titles',
    },
  },

  // Price Suggestion
  price: {
    title: 'Smart Price Estimate',
    subtitle: 'Get a fair price estimate based on market data',
    estimate: 'Estimated Price',
    range: 'Price Range',
    low: 'Low',
    high: 'High',
    market: 'Market Average',
    confidence: 'Confidence Level',
    factors: {
      title: 'Factors affecting valuation',
      location: 'Location',
      size: 'Size',
      age: 'Property Age',
      condition: 'Condition',
      amenities: 'Amenities',
      market: 'Market Conditions',
    },
    getSuggestion: 'Get Estimate',
    disclaimer: 'This estimate is for guidance only. Actual price may vary based on other factors',
  },

  // Competition Analysis
  competition: {
    title: 'Competition Analysis',
    subtitle: 'Discover how your property compares to similar listings',
    analyze: 'Analyze Competition',
    similarListings: 'Similar Listings',
    priceComparison: 'Price Comparison',
    yourPrice: 'Your Price',
    averagePrice: 'Market Average',
    recommendation: 'Recommendation',
    metrics: {
      viewsAvg: 'Average Views',
      daysOnMarket: 'Days on Market',
      inquiriesAvg: 'Average Inquiries',
    },
  },

  // Best Time to Post
  bestTime: {
    title: 'Best Time to Post',
    subtitle: 'Choose the optimal time to publish your listing',
    bestDays: 'Best Days',
    bestHours: 'Best Hours',
    recommendation: 'We recommend posting',
    viewerActivity: 'Viewer Activity',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
  },

  // AI Assistant Widget
  assistant: {
    title: 'AI Assistant',
    greeting: 'Hello! How can I help you today?',
    placeholder: 'Type your question here...',
    send: 'Send',
    suggestions: {
      title: 'Suggestions',
      writeDescription: 'Write a description for my property',
      suggestPrice: 'What is a fair price?',
      improveTitle: 'Improve my listing title',
      analyzMarket: 'Analyze the area market',
    },
  },

  // Error messages
  errors: {
    generateFailed: 'An error occurred during generation, please try again',
    inputRequired: 'Please enter property information',
    networkError: 'Connection error, please check your internet',
  },
};

export default ai;
